<!-- This component is used to render the plan holder dropdown in the left side bar, showing the plan holder's name and avatar. -->
<template>
	<Disclosure
		:defaultOpen="defaultOpen"
		v-slot="{ open }"
	>
		<DisclosureButton
			:id="plan.id + '-toggle'"
			class="flex items-center justify-between px-4 py-2 text-left"
			:aria-label="t('document.planHolderToggle')"
			:disabled="disabled"
		>
			<div class="flex items-center gap-3">
				<CheckIcon
					v-if="disabled"
					class="text-accent-500 mx-1 h-8 w-8"
				/>
				<PlanAvatar
					v-else
					:plan="plan"
					:index="index"
					:filled="open"
				/>
				<span
					v-if="expanded"
					class="animate-fade-in-delay font-bold opacity-0"
					:class="{
						'text-primary-400!': open && !disabled,
						'text-secondary-900!': !open && !disabled,
						'text-secondary-400!': disabled,
					}"
				>
					{{ plan.firstName }} {{ plan.lastName }}
				</span>
			</div>
			<ChevronRightIcon
				v-if="expanded && !disabled"
				:class="{ 'rotate-90 transform': open }"
				class="h-5 w-5 text-xs text-slate-500! transition-transform duration-200"
			/>
		</DisclosureButton>
		<DisclosurePanel
			class="flex flex-col text-gray-500!"
			:class="{ 'items-center': !expanded }"
		>
			<slot v-if="!disabled" />
		</DisclosurePanel>
	</Disclosure>
</template>

<script setup lang="ts">
import Plan from '@/classes/Plan'
import PlanAvatar from '@/components/presentation/PlanAvatar.vue'
import { usePresentationLocale } from '@/i18n'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronRightIcon, CheckIcon } from '@heroicons/vue/24/solid'

const { t } = usePresentationLocale()
defineProps<{
	plan: Plan
	index: number
	defaultOpen?: boolean
	expanded: boolean
	disabled: boolean
}>()
</script>
